import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialDataGrid from "../../../components/MaterialDataGrid";
import MaterialTypography from "../../../components/MaterialTypography";
import { Card, CardHeader, CardContent, Typography, Grid, Stack, Button, TextField } from '@mui/material';
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../../Utils/Baseurl";

function Shift_viewscreen() {
   const [employeeData,setemployeeData] = useState([])
   const navigate = useNavigate()
    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search)
        const id = queryParams.get("id")
        
        if (id) {
            getInitData(id)
        }
       
    }, [])


    const getInitData = async (id) => {
      
        const query = `query GetTimeemfById($id: ID!) {
  timeemfById(id: $id) {
    id
    name
    startTime
    endTime
  }
}`
        try {
         
            const response = await axios.post(BASEURL, {
                query: query,
                variables: { id },
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            

            const shiftRowData = response.data.data.timeemfById
            setemployeeData(shiftRowData)
          
        } catch (error) {
            console.error('ResponseError:', error);
          
        }
    };


     function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB'); // This will return 'dd/mm/yyyy' format
      }

      const handleclose = ()=>{
        navigate('/weekoff')
      }
   
  return (
    <DashboardLayout>
    <Card>
        <CardHeader
          title={
            <Stack direction="column" spacing={0}>
              <Typography  variant="h5" fontWeight="bold">
               Shift Details
              </Typography>
            </Stack>
          }
          
        />
        <CardContent>
          <Grid container spacing={1}  marginLeft={"4%"}>
            {/* Left Column */}
            <Grid item xs={4}>
              <Stack spacing={4}>
                <Typography  variant="h6" fontWeight="bold">Shift Name: <span style={{color:"#67748E"}}>{employeeData.name}</span></Typography>
                <Typography  variant="h6" fontWeight="bold">End Time: <span style={{color:"#67748E"}}>{employeeData.endTime}</span> </Typography>
            
              </Stack>
            </Grid>

            {/* Right Column */}
            <Grid item xs={4}>
              <Stack spacing={4}>
              <Typography variant="h6" fontWeight="bold">Start Time: <span style={{color:"#67748E"}}>{employeeData.startTime}</span> </Typography>

              </Stack>
            </Grid>

            {/* Close Button */}
            <Grid item xs={12} textAlign="center" marginTop={2} sx={{marginLeft:"-11%"}}>
            <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={handleclose}
                        style={{ maxWidth: "100px", minWidth: "100px" }}
                        // disabled={
                        //     !handleActiveStep()
                        // }
                      >
                        Close
                        
                      </MaterialButton>
            </Grid>
          </Grid>
         
        </CardContent>
      </Card>
  </DashboardLayout>
  );
}

export default Shift_viewscreen;
